export default __webpack_public_path__ + "static/reduce-icon-c0444179d79dc9396cbc19ee47c6ddfe.svg";